import Tabs from '@/components/Tabs'
import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import organizationTabs from '@/router/tabsSystems/organizationTabs'

function Organization() {
  return (
    <Flex component='section' gap={4} grow>
      <Text variant='h1'>Organization</Text>
      <Tabs tabs={organizationTabs} />
    </Flex>
  )
}

export default Organization
